import { CanvasRowWidthType } from "../../../@types";
import SortableItem from "../SortableItem";

type Props = {
  id: string;
  name: string;
  title: string;
  className?: string;
  width: CanvasRowWidthType;
  onRemove: (id: string) => void;
};
const SvgLayoutBlock = ({
  id,
  name,
  title,
  className = "",
  width,
  onRemove
}: Props) => (
  <SortableItem id={id} title={title} width={width} onRemove={onRemove}>
    <img
      className={className}
      alt={name}
      src={`${window.tcbase.urls.static}images/layout_blocks/${name}.svg`}
    ></img>
  </SortableItem>
);

export default SvgLayoutBlock;
